import { useState, useCallback } from "react";
import { Button, Spin, Typography } from "antd";
import { SyncOutlined, ClockCircleOutlined } from "@ant-design/icons";
import Header from "../../../components/HeaderList";
import styles from "../styles/UberSyncUI.module.css";

// Import custom sub-components
import BranchesTable from "./BranchesTable";
import MenuPreviewPanel from "./MenuPreviewPanel";
import ConflictsPanel from "./ConflictsPanel";
import SyncProgressModal from "./SyncProgressModal";
import MenuDetailDrawer from "./MenuDetailDrawer";
import ExclusionsDetailDrawer from "./ExclusionsDetailDrawer";

const UberSyncUI = (props) => {
  const {
    loading,
    branches,
    selectedRowKeys,
    onSelectRowKeysChange,
    previewLoading,
    previewMenu,
    previewExclusions,
    previewDiscrepancies,
    previewRawPayload,
    liveMenuLoading,
    liveMenu,
    liveRawPayload,
    syncModalVisible,
    syncLoading,
    syncResults,
    onTriggerSync,
    onCloseSyncModal,
    lastSyncTime
  } = props;

  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [exclusionsDrawerVisible, setExclusionsDrawerVisible] = useState(false);

  const selectedCount = selectedRowKeys.length;

  const handleOpenMenuDrawer = useCallback(() => {
    setMenuDrawerVisible(true);
  }, []);

  const handleCloseMenuDrawer = useCallback(() => {
    setMenuDrawerVisible(false);
  }, []);

  const handleOpenExclusionsDrawer = useCallback(() => {
    setExclusionsDrawerVisible(true);
  }, []);

  const handleCloseExclusionsDrawer = useCallback(() => {
    setExclusionsDrawerVisible(false);
  }, []);

  return (
    <div className={styles.view}>
      <header className={styles.header}>
        <Header
          title="SINCRONIZACIÓN DE MENÚS CON UBER EATS"
          style={{ marginBottom: 0 }}
        />
        <div className={styles.syncBtnContainer}>
          <Button
            type="primary"
            className={styles.syncButton}
            icon={<SyncOutlined spin={syncLoading} />}
            disabled={selectedCount === 0 || syncLoading}
            onClick={onTriggerSync}
            size="large"
            block
          >
            Sincronizar Uber ({selectedCount} sucursales)
          </Button>
          {lastSyncTime && (
            <Typography.Text type="secondary" className={styles.lastSyncText}>
              <ClockCircleOutlined /> Última sync: {lastSyncTime}
            </Typography.Text>
          )}
        </div>
      </header>

      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" tip="Cargando configuración de Uber..." />
        </div>
      ) : (
        <div className={styles.cardGrid}>
          {/* Panel Izquierdo: Selección de Sucursales */}
          <BranchesTable
            branches={branches}
            selectedRowKeys={selectedRowKeys}
            onSelectRowKeysChange={onSelectRowKeysChange}
          />

          {/* Panel Derecho: Previsualización y Exclusiones */}
          <div className={styles.rightPanelWrapper}>
            <div className={styles.rightPanel}>
              {/* Previsualización del Menú Global */}
              <MenuPreviewPanel
                previewLoading={previewLoading}
                previewMenu={previewMenu}
                previewRawPayload={previewRawPayload}
                liveRawPayload={liveRawPayload}
                onOpenDrawer={handleOpenMenuDrawer}
              />

              {/* Panel de Conflictos y Alertas */}
              <ConflictsPanel
                previewLoading={previewLoading}
                previewExclusions={previewExclusions}
                previewDiscrepancies={previewDiscrepancies}
                onOpenDrawer={handleOpenExclusionsDrawer}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal de Progreso de Sincronización */}
      <SyncProgressModal
        visible={syncModalVisible}
        loading={syncLoading}
        results={syncResults}
        onClose={onCloseSyncModal}
      />

      {/* Drawer para ver el Menú Completo */}
      <MenuDetailDrawer
        visible={menuDrawerVisible}
        menu={previewMenu}
        liveMenuLoading={liveMenuLoading}
        liveMenu={liveMenu}
        onClose={handleCloseMenuDrawer}
      />

      {/* Drawer para ver Conflictos y Exclusiones */}
      <ExclusionsDetailDrawer
        visible={exclusionsDrawerVisible}
        exclusions={previewExclusions}
        discrepancies={previewDiscrepancies}
        onClose={handleCloseExclusionsDrawer}
      />
    </div>
  );
};

export default UberSyncUI;
